import { Injectable, signal } from '@angular/core';
import {
  HdChannelListChannelInfoRequest,
  HdChannelListGateInfoRequest,
} from '../bodygraph/channel-list/hd-channel-list-item.component';
import { HdCycleCenterBlockInfoRequest } from '../bodygraph/advanced-properties/hd-cycle-conditioned-center-block.component';
import { HdBodygraphConfig, HdBodygraphPlanetaryActivation } from '../bodygraph/hd-bodygraph.models';

/**
 * Doorklik-handlers van de chart-pagina (zelfde shapes als de kliks in de
 * chart en de keynote-secties); het paneel opent zelf geen info-panelen, zodat
 * de open-gedrag-instellingen (dock/dialog) en de transitlaag gerespecteerd blijven.
 */
export interface HdJustNowPanelRequestHandlers {
  readonly openGateInfo: (request: HdChannelListGateInfoRequest) => void;
  readonly openChannelInfo: (request: HdChannelListChannelInfoRequest) => void;
  readonly openCenterInfo: (request: HdCycleCenterBlockInfoRequest) => void;
}

/**
 * Gedeelde staat van het Just Now-paneel. De chart-pagina bezit de Just
 * Now-overlaymodus (aan/uit, snapshot, tijdslider) en spiegelt hierheen wat het
 * gedockte paneel nodig heeft: de natal chart, de transitactivaties van de
 * effectieve snapshot (slider-sample wint) en het moment. Zelfde
 * service-patroon als `HdLocksKeysStateService`, zodat het floating-panel geen
 * live callbacks door zijn data-token hoeft te slepen.
 */
@Injectable({ providedIn: 'root' })
export class HdJustNowPanelStateService {
  /** Natal configuratie van de getoonde chart (gefilterd op de zichtbare zijde, zoals de overlay). */
  readonly natalConfiguration = signal<HdBodygraphConfig>({ schemaVersion: 1, activations: [] });
  /** Natal planeetactivaties (poort-chips van de kanaal-items). */
  readonly natalPlanetaryActivations = signal<readonly HdBodygraphPlanetaryActivation[]>([]);
  /** Personality-activaties van het transitmoment (de overlay-laag). */
  readonly transitActivations = signal<readonly HdBodygraphPlanetaryActivation[]>([]);
  /** Het getoonde moment (ISO UTC); volgt de tijdslider. `undefined` = modus uit. */
  readonly momentUtc = signal<string | undefined>(undefined);
  readonly chartName = signal('');
  /** Door de pagina geregistreerd zolang ze leeft; `undefined` = geen doorklik mogelijk. */
  readonly requestHandlers = signal<HdJustNowPanelRequestHandlers | undefined>(undefined);

  /** Modus uit: alles leeg, zodat een nog gemount paneel niets verouderds toont. */
  clear(): void {
    this.natalConfiguration.set({ schemaVersion: 1, activations: [] });
    this.natalPlanetaryActivations.set([]);
    this.transitActivations.set([]);
    this.momentUtc.set(undefined);
    this.chartName.set('');
  }
}
